import { PrimaryButtonProps } from '@components/Buttons/primary';
import { InlineFlex } from '@components/Layout/Blocks';
import { Col } from '@components/Layout/Col';
import { Row, RowProps } from '@components/Layout/Row';
import Container from '@material-ui/core/Container';
import { FooterMountPoint } from '@packages/layout/lib/UIShell/FooterMountPoint';
import { MountTo } from '@packages/portals';
import { createMemo } from '@packages/react';
import React from 'react';
import styled from 'styled-components';
import { NextTab } from './NextTab';
import { PreviousTab } from './PreviousTab';

interface TabFooterProps extends RowProps {
    fullPage?: boolean;

    hide?: boolean;
    hidePrevious?: boolean;
    hideNext?: boolean;

    disabled?: boolean;
    disablePrevious?: boolean;
    disableNext?: boolean;
    backgroundColor?: string;

    previousProps?: PrimaryButtonProps;
    nextProps?: PrimaryButtonProps;
}

export const TabFooter = createMemo<TabFooterProps>(
    ({
        hide,
        hidePrevious,
        hideNext,
        disabled,
        disablePrevious,
        disableNext,
        previousProps,
        nextProps,
        backgroundColor = 'rgba(249,249,249, .8)',
        fullPage,
        children,
        ...rest
    }) => {
        if (fullPage && previousProps && previousProps.variant === 'outlined' && !previousProps.color) {
            previousProps.color = 'dark';
        }

        const children$ = (
            <Row padding={'0 24px'} align={'center'} justify={'center'} {...rest}>
                {hide || hidePrevious ? null : (
                    <InlineFlex component={Col} xs style={{ padding: 0 }} m={'0 8px'} maxWidth={110}>
                        <PreviousTab
                            margin={0}
                            disabled={disabled || disablePrevious}
                            fullWidth
                            {...(previousProps || {})}
                        />
                    </InlineFlex>
                )}
                {hide || hideNext ? null : (
                    <InlineFlex component={Col} xs style={{ padding: 0 }} m={'0 8px'} maxWidth={110}>
                        <NextTab margin={0} disabled={disabled || disableNext} fullWidth {...(nextProps || {})} />
                    </InlineFlex>
                )}
                {children}
            </Row>
        );

        return fullPage ? (
            <MountTo to={FooterMountPoint.POINT} name={'order-stepper-footer'} order={20}>
                <FullPageFooter style={{ backgroundColor }}>
                    <Container maxWidth="md">{children$}</Container>
                </FullPageFooter>
            </MountTo>
        ) : (
            children$
        );
    },
    {
        displayName: 'TabFooter',
        defaultProps: {
            previousProps: { variant: 'outlined' },
        },
    },
);

const FullPageFooter = styled.footer`
    & {
        width: 100%;
        padding-top: 15px;
        padding-bottom: 15px;
        border-top: 1px solid #ccc;
        backdrop-filter: blur(5px);

        .material-icons {
            font-size: 1.15rem;
            margin-left: 0.25rem;
        }
    }
`;
